var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParkingLocationIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 74,
    viewBox: "0 0 50 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7655 0.0242682C10.9193 0.647128 0.394981 11.468 0.00805218 24.4688C-0.146872 30.6968 1.9427 36.3796 5.50273 40.8949C10.7647 47.5123 14.7889 54.9855 17.7297 62.926C18.7359 65.651 19.6643 68.2977 20.5156 70.7886C21.986 75.0704 28.022 75.0704 29.4925 70.7886C30.3437 68.2972 31.2722 65.6505 32.2784 62.926C35.1415 55.0635 39.0108 47.5898 44.2733 41.1284C47.8333 36.769 50 31.2415 50 25.1694C49.9989 10.8452 38.1589 -0.598522 23.7648 0.0242682H23.7655ZM25.0038 42.5297C15.4855 42.5297 7.74676 34.7448 7.74676 25.1694C7.74676 15.5942 15.4853 7.80914 25.0038 7.80914C34.5223 7.80914 42.2608 15.594 42.2608 25.1694C42.2608 34.7447 34.5223 42.5297 25.0038 42.5297Z",
    fill: "#FF5910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3125 14H20.5233C19.6854 14 19 14.7045 19 15.5657V34.982C19 35.5303 19.457 36 19.9904 36H22.6568C23.1903 36 23.6472 35.5303 23.6472 34.982V29.2669H26.618C31.0361 29.2669 34.5399 25.2741 33.931 20.6545C33.3965 16.8181 30.0448 14 26.3125 14H26.3125ZM26.5409 24.4909H23.5701V18.7758H26.5409C28.0643 18.7758 29.3593 20.0286 29.3593 21.6724C29.3593 23.3163 28.0644 24.4909 26.5409 24.4909Z",
    fill: "#FF5910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingLocationIconOrange);
export default __webpack_public_path__ + "static/media/parkingLocationIconOrange.1e70adbcf2432adf174d2d0e95cf9442.svg";
export { ForwardRef as ReactComponent };